import React from "react";

function EducationRules() {
  return <div>EducationRules</div>;
}

export default EducationRules;
